import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=c0734ede&"
import script from "./edit.vue?vue&type=script&scoped=true&lang=js&"
export * from "./edit.vue?vue&type=script&scoped=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0734ede')) {
      api.createRecord('c0734ede', component.options)
    } else {
      api.reload('c0734ede', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=c0734ede&", function () {
      api.rerender('c0734ede', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/formSys/edit.vue"
export default component.exports